/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { withTranslation } from "react-i18next";
import ScrollToTop from "react-scroll-up";
import { makeStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import VerticalAlignTopIcon from "@material-ui/icons/VerticalAlignTop";
import { useThemeData } from "../../context/ThemeDataContext";

function Footer(props) {
  const {
    primary_color_1,
    primary_color_6,
    background_color_8,
    font_family_link,
  } = useThemeData().themeData.site.theme;
  const { menus, emails } = useThemeData().themeData.site;

  const { navigation, contact_footer } = useThemeData().modules;
  const company_info = emails[0];
  let width = localStorage.getItem("screen-width");

  const useStyles = makeStyles(() => ({
    navlink: {
      color: `${primary_color_1} !important`,
      "&:hover": {
        color: `${primary_color_6} !important`,
      },
    },
  }));
  const classes = useStyles();

  const [date, setDate] = useState();
  const getYear = () => setDate(new Date().getFullYear());

  useEffect(() => {
    getYear();
  }, []);

  if (!menus) return null;
  if (navigation !== "true" && navigation !== true) return null;
  return (
    <div>
      <Typography
        className={`justify-content-center top-footer`}
        style={{
          fontFamily: `${font_family_link}`,
          backgroundColor: `${background_color_8}`,
          padding: '10px 0px',
        }}
      >
        {contact_footer && (
          <NavLink
            className={`${classes.navlink} padding-around`}
            exact
            to={"/contact"}
          >
            {props.t("footer:For Questions")} {company_info.email}
          </NavLink>
        )}
        {menus.length >= 1 &&
          menus
            .filter(
              (f) =>
                f.naam !== "Hoofdmenu" &&
                f.hoofd_pagina_id === "0" &&
                f.url !== "login" &&
                f.url !== "succes"
            )
            .map((menuItems, index) => (
              <NavLink
                key={index}
                className={`${classes.navlink} padding-around`}
                to={`/${menuItems.url}`}
              >
                {menuItems.naam}
              </NavLink>
            ))}
        <Link
          href={`https://fotoprotools.nl/`}
          target="_blank"
          className={`${classes.navlink} padding-around`}
        >
          © Copyright {date} Fotoprotools
        </Link>
      </Typography>

      <ScrollToTop
        showUnder={160}
        style={{
          bottom: `${
            width <= 375
              ? "22vh"
              : width <= 425
              ? "17vh"
              : width <= 768
              ? "12vh"
              : "10vh"
          }`,
        }}
      >
          <div className="btn btn-light align-button"
               style={{
                   fontFamily: `${font_family_link}`,
                   backgroundColor: `${background_color_8}`,
                   borderRadius: `0.25rem`,
                   padding: `0px`,
                   color: `${primary_color_1}`,
          }}>
              <VerticalAlignTopIcon color="inherit" />
          </div>
      </ScrollToTop>
    </div>
  );
}

export default React.memo(withTranslation(["message", "footer"])(Footer));
